import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  MultiAutocomplete,
  RadioGroup,
  Hidden,
} from '~/components/Form';
import { CRUDProfile, PesquisaTabela } from '~/components/Form/v2';
import { REL_TRANSFERENCIA } from '~/constants/default';
import { t } from '~/helpers';

function Reltransferencia() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [produto, setProduto] = useState(0);
  const [bico, setBico] = useState(0);
  const [close, setClose] = useState(false);

  const [valuePostoDestino, setValuePostoDestino] = useState(0);
  const [inputValuePostoDestino, setInputValuePostoDestino] = React.useState(
    ''
  );

  const [valuePosto, setValuePosto] = React.useState([]);
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');
  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal, idproduto } = params;

    // let vidproduto = '';
    // let formidproduto = document.getElementById('idproduto');
    // if (formidproduto.innerText === '') {
    //   vidproduto = '';
    // } else {
    //   vidproduto = idproduto;
    // }

    let idPostodestinomovimentacaotransferencia;

    if (params.idpostodestinomovimentacaotransferencia !== null) {
      idPostodestinomovimentacaotransferencia =
        params.idpostodestinomovimentacaotransferencia;
    } else {
      idPostodestinomovimentacaotransferencia = '';
    }

    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;
    const idProduto = valueProduto === 0 ? '' : valueProduto;
    return {
      ...params,
      idproduto: idProduto,
      idposto: idPosto,
      idbico: idBico,
      idpostodestinomovimentacaotransferencia: idPostodestinomovimentacaotransferencia,
      nomepostodestinomovimentacaotransferencia: inputValuePostoDestino,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.reltransferencia')}
      relatorio="reltransferencia"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        idperfilrelatorio: '0',
        idgrupocamposistema: REL_TRANSFERENCIA,
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        onChangeValueExpecific={() => setClose(false)}
        title={t('s.geral.pontoorigem')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          setValuePosto(0);
          setInputValuePosto('');

          setValueBico(0);
          setInputValueBico('');

          setValueProduto(0);
          setInputValueProduto('');

          setBico(0);
          setProduto(0);
          setValueBico(0);
          setValuePosto(value);
        }}
      />

      <Autocomplete
        open={close}
        onClose={() => setClose(false)}
        onOpen={() => setClose(true)}
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        getValue={(value) => {
          setValueBico(value.idbico);
          setValueProduto(0);
          setInputValueProduto('');

          const formidproduto = document.getElementById('idproduto');
          formidproduto.innerText = '';

          // if (JSON.stringify(value.) === '{}') {
          if (value.idbico === null) {
            setBico(0);
            setProduto(0);
          } else {
            setProduto(value.idproduto);
            setBico(value.idbico);
          }
        }}
        params={{
          wherefield: 'idposto',
          valuewherefield: valuePosto[0]?.idposto,
          typewherefield: 'EQUALS',
        }}
      />

      <Autocomplete
        id="idproduto"
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        disabled={bico !== 0}
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProduto) => {
          setInputValueProduto(newInputValueProduto);
        }}
        getValue={(value) => {
          if (value.idproduto !== null) {
            setValueProduto(value.idproduto);
          } else {
            setValueProduto(0);
          }
          setValueBico(0);
          setInputValueBico('');
        }}
        // first={[{ nomeabreviadoproduto: 'TODOS', value: '' }]}
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
      />

      <Autocomplete
        id="idpostodestinomovimentacaotransferencia"
        name="idpostodestinomovimentacaotransferencia"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        // first={[{ nomeposto: 'TODOS', value: '' }]}
        title={t('s.geral.pontodestino')}
        value={valuePostoDestino}
        inputValue={inputValuePostoDestino}
        onChange={(event, newValue) => {
          setValuePostoDestino(newValue);
        }}
        onInputChange={(event, newInputValuePostoDestino) => {
          setInputValuePostoDestino(newInputValuePostoDestino);
        }}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoposto' }]}
      />

      <PesquisaTabela
        name="frentista"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <CRUDProfile
        name="idperfilrelatorio"
        label={t('s.menu.cadastro.usuario.perfil')}
        report={REL_TRANSFERENCIA}
        nameReport={t('s.menu.operacao.transferencia')}
      />

      <Hidden name="idgrupocamposistema" />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Reltransferencia;
